export default __webpack_public_path__ + "static/media/kitchen.76761dfd.jpg";